import Avatar from 'components/base/Avatar';
import { Dropdown, Modal, Nav, Toast, ToastContainer } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
//import NineDotMenu from './NineDotMenu';
import { useAppContext } from 'providers/AppProvider';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import NotificationDropdownMenu from './NotificationDropdownMenu';
import ThemeToggler from 'components/common/ThemeToggler';
import { useState } from 'react';
import DropdownSearchBox from 'components/common/DropdownSearchBox';
import SearchResult from 'components/common/SearchResult';
import classNames from 'classnames';
import Badge from 'components/base/Badge';
import { MessageType, useSSE } from 'providers/SSEProvider';
import { useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider'

interface ToastMessage {
  id: number;
  message: MessageType;
  show: boolean;
}


const NavItems = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();


  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [previousNotificationsCount, setPreviousNotificationsCount] = useState(0);
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const { notifications, markAllNotificationsAsread } = useSSE();
  const auth = useAuth();

  useEffect(() => {

    // code for toast management
    if (notifications.length > previousNotificationsCount) {
      const login_at = auth.user?.login_at || new Date();
      // Show toast for the new notifications
      //const newNotifications = notifications.slice(previousNotificationsCount);
      // Since the newer notifications are at the beginning of the array, slice from 0 to the difference in length
      const newNotifications = notifications.slice(0, notifications.length - previousNotificationsCount);
      // Filter out notifications that are earlier than loginAt
      const filteredNotifications = newNotifications.filter(notification =>
        new Date(notification.inserted_at) > new Date(login_at)
      );

      // Map the MessageType to ToastMessage
      const newToastMessages = filteredNotifications.map((message) => ({
        id: message.notification_id,
        show: true,
        message: message, // Store the original message
      }));

      setToasts((prevToasts) => [...prevToasts, ...newToastMessages]);
      setPreviousNotificationsCount(notifications.length);
    }
  }, [notifications, previousNotificationsCount]);

  const notificationCount = notifications ? notifications.filter(notification => notification.to_read === 1).length : 0;
  const handleRemoveToast = (id: number) => {
    // Set the 'show' attribute to false instead of removing the toast
    setToasts((prevToasts) =>
      prevToasts.map((toast) =>
        toast.id === id ? { ...toast, show: false } : toast
      )
    );
  };

  return (
    <>
      <div className="position-fixed bottom-0 end-0 p-3">
        <ToastContainer className="position-static">
          {toasts.map((toast, index) => (
            <Toast key={index} onClose={() => handleRemoveToast(toast.id)} show={toast.show} delay={3000} autohide>
              <Toast.Header closeButton={true}>
                <strong className="me-auto">{toast.message.function}</strong>
              </Toast.Header>
              <Toast.Body>{toast.message.message}</Toast.Body>
            </Toast>
          ))}
        </ToastContainer>
      </div>

      < div className="navbar-nav navbar-nav-icons flex-row flex-grow-1  justify-content-end" >
        {/* Elementi a destra */}
        <Nav.Item>
          <ThemeToggler className="px-2" />
        </Nav.Item>
        <Nav.Item
          className={classNames({
            'd-lg-none':
              navbarPosition === 'vertical' || navbarPosition === 'dual'
          })}
        >
          <Nav.Link onClick={() => setOpenSearchModal(!openSearchModal)}>
            <FeatherIcon icon="search" size={19} style={{ marginBottom: 2 }} />
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Dropdown autoClose="outside" className="h-100">
            <Dropdown.Toggle
              as={Link}
              to="#!"
              className="dropdown-caret-none nav-link h-100"
              variant=""
            >
              <FeatherIcon icon="bell" size={20} />
              {notificationCount > 0 && <Badge bg="danger" style={{
                position: 'absolute', top: 0, right: '-4px'
              }}>{notificationCount}</Badge>}

            </Dropdown.Toggle>
            <NotificationDropdownMenu notifications={notifications} onMarkAllRead={markAllNotificationsAsread} />
          </Dropdown>
        </Nav.Item>

        <Nav.Item>
          <Dropdown autoClose="outside" className="h-100">
            <Dropdown.Toggle
              as={Link}
              to="#!"
              className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
              variant=""
            >
              {auth.user && <Avatar src={auth.user.picture} size="xl" />}

            </Dropdown.Toggle>
            <ProfileDropdownMenu />
          </Dropdown>
        </Nav.Item>

        <Modal
          show={openSearchModal}
          onHide={() => setOpenSearchModal(false)}
          className="search-box-modal mt-15"
        >
          <Modal.Body className="p-0 bg-transparent">
            <DropdownSearchBox
              className="navbar-top-search-box"
              inputClassName="rounded-pill"
              size="lg"
              style={{ width: 'auto' }}
            >
              <SearchResult />
            </DropdownSearchBox>
          </Modal.Body>
        </Modal>
      </div >
    </>
  );
};

export default NavItems;
